import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../AxiosConfig"
import PageHero from "../../components/common/PageHero";
import DataTableCard from "../../components/common/DataTableCard";
import { Button, Input } from "reactstrap";

// API
import { _Get } from "../../ApiEndPoint/ApiCalling";
import { Create_Account_List } from "../../ApiEndPoint/Api";

export default function UsersList() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // 🔥 API CALL
  const fetchUsers = async () => {
    try {
      setLoading(true);

      const userinfo = JSON.parse(localStorage.getItem("userData"));

      const url = `${Create_Account_List + userinfo?._id}/`;

      const res = await axiosConfig(
        `/user/view-user-by-id/${userinfo?._id}/${userinfo?.database}`
      );
      let data = res?.data?.adminDetails || [];

      // filter active users & remove self role
      const filtered = data.filter(
        (ele) =>
          ele?.status === "Active"
      );

      setRows(filtered);
      setAllData(filtered);
    } catch (err) {
      console.log(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // 🔥 SEARCH FILTER
  useEffect(() => {
    let filtered = allData.filter((item) => {
      const searchText = search.toLowerCase();

      return (
        item?.firstName?.toLowerCase().includes(searchText) ||
        item?.email?.toLowerCase().includes(searchText) ||
        item?.mobileNumber?.includes(searchText)
      );
    });

    setRows(filtered);
  }, [search]);

  return (
    <div className="erp-page-grid">

      {/* 🔥 HEADER ROW */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {/* LEFT SIDE */}
        <h3 style={{ margin: 0 }}>Users List</h3>

        {/* RIGHT SIDE */}
        <div style={{ display: "flex", gap: "10px" }}>
          <Input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "220px" }}
          />

          <Button
            color="primary"
            onClick={() => navigate("?view=create-user")}
          >
            + User
          </Button>
        </div>
      </div>

      {/* 🔥 TABLE */}
      <DataTableCard
        loading={loading}
        columns={[
          { key: "id", label: "ID" },
          { key: "name", label: "Full Name" },
          { key: "email", label: "Email" },
          { key: "mobile", label: "Mobile" },
          { key: "role", label: "Role" },
          { key: "city", label: "City" },
        ]}
        rows={rows.map((r) => ({
          id: r?.id,
          name: r?.firstName,
          email: r?.email,
          mobile: r?.mobileNumber,
          role: r?.rolename?.roleName,
          city: r?.City,
        }))}
      />
    </div>
  );
}